import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SafeApp } from './App.tsx';
import { registerPwaUpdates } from './pwa-update.ts';
import './styles.css';

registerPwaUpdates();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SafeApp />
  </StrictMode>,
);
